import { render, staticRenderFns } from "./check-plus.vue?vue&type=template&id=5fd68e1a&scoped=true"
import script from "./check-plus.vue?vue&type=script&lang=js"
export * from "./check-plus.vue?vue&type=script&lang=js"
import style0 from "./check-plus.vue?vue&type=style&index=0&id=5fd68e1a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fd68e1a",
  null
  
)

export default component.exports